<script lang="ts">
	interface Props {
		row: Record<string, any>
		key: string
		onTitleClick?: (row: Record<string, any>) => void
		size?: 'sm' | 'base' | 'lg'
	}

	let { row, key, onTitleClick, size = 'base' }: Props = $props()

	const label = $derived(row[key])
	const subtitle = $derived(row.subtitle)

	const handleClick = (e: MouseEvent) => {
		e.stopPropagation()
		if (onTitleClick) {
			onTitleClick(row)
		}
	}
</script>

<div class="labelContainer">
	{#if onTitleClick}
		<button
			type="button"
			class="label clickable"
			class:text-sm={size === 'sm'}
			class:text-base={size === 'base'}
			class:text-lg={size === 'lg'}
			onclick={handleClick}
		>
			{label}
		</button>
	{:else}
		<span class="label">{label}</span>
	{/if}
	{#if subtitle}
		<span class="subtitle">{subtitle}</span>
	{/if}
</div>

<style>
	.labelContainer {
		@apply flex flex-col items-start;
	}

	.label {
		@apply font-normal leading-6 text-[#606266];
	}

	.clickable {
		@apply text-[#007acc] font-semibold underline underline-offset-auto decoration-solid decoration-[auto] cursor-pointer;
	}

	.subtitle {
		@apply text-sm font-normal leading-5 text-[#001D33B3];
	}
</style>
